const formatFieldErrors = (errorsObj) => {
  return Object.entries(errorsObj)
    .map(([field, errors]) => {
      const label = field
        .replace(/_/g, ' ')
        .replace(/\b\w/g, (c) => c.toUpperCase());
      const msgs = Array.isArray(errors) ? errors : [String(errors)];
      const unique = [...new Set(msgs)];
      return `${label}: ${unique.join(', ')}`;
    })
    .join('. ');
};

export const parseApiError = (errorJson, fallback = 'Something went wrong. Please try again.') => {
  if (!errorJson) return fallback;

  const msg = errorJson.msg;
  if (!msg) return fallback;

  if (typeof msg === 'string') return msg;

  if (Array.isArray(msg)) {
    const text = msg.map((m) => m.value || m.message || m).filter(Boolean).join('. ');
    return text || fallback;
  }

  // Field-level details take priority — most specific
  if (msg.details && typeof msg.details === 'object') {
    const text = formatFieldErrors(msg.details);
    if (text) return text;
  }

  if (msg.error) {
    if (typeof msg.error === 'string') return msg.error;
    if (typeof msg.error === 'object') {
      const text = formatFieldErrors(msg.error);
      if (text) return text;
    }
  }

  if (typeof msg.message === 'string') return msg.message;
  if (typeof msg.status === 'string') return msg.status;

  return fallback;
};
